import {
    IRouteDetails,
} from '../../../../../common/components/load-card/load-card-body/ILoadCardBody';
import {
    StatusTagProps,
} from '../../../../../common/components/load-card/load-card-header/ILoadCardHeader';
import LoadStatus from '../../../../../common/enums/loads/load-status.enum';
import ILoadListData from '../../../../../common/interfaces/loads/ILoadListData';
import ILoadRate from '../../../../../common/interfaces/loads/ILoadRate';
import ILoadRoute from '../../../../../common/interfaces/loads/ILoadRoute';
import i18n from '../../../../../lib/i18n';
import IPoolLoadCardInfo from '../interfaces/IPoolLoadCardInfo';

interface IPoolLoadRouteDetails {
    source: IRouteDetails;
    destination: IRouteDetails;
}

export const statusMap = {
    Confirmed: LoadStatus.Confirmed,
    WaitingConfirmation: LoadStatus.WaitingConfirmation,
} as { [key: string]: LoadStatus };

export function getPoolLoadCardInfo(load: ILoadListData): IPoolLoadCardInfo {
    return {
        idLoad: load.loadId,
        tagStatus: statusMap[load.status],
        routeDetails: {
            destination: load.route!.destination,
            destinationCode: load.route!.destination.code,
            destinationDescription: load.route!.destination.description,
            source: load.route!.source,
            originCode: load.route!.source.code,
            originDescription: load.route!.source.description,
            collectionDate: load.dates!.collectionDate,
        },
        channel: load.channel,
        shipmentNumber: load.shipmentNumber,
        sapOrderNumber: load.sapOrderNumber,
        rate: load.rate
            ? {
                  code: load.rate?.code,
                  rateCarrierCode: load.rate?.rateCarrierCode,
                  serviceCode: load.rate?.serviceCode,
                  vehicle: load.rate?.vehicle,
                  chargeAmount: load.rate?.chargeAmount,
                  carrierScoreCard: load.rate?.carrierScoreCard,
                  carrierId: load.rate?.carrierId,
                  corporateName: load.rate?.corporateName,
                  sulahubId: load.rate?.sulaHubId,
              }
            : undefined,
        shipment: {
            currency: load.shipment.currency,
            material: load.shipment.material.name,
            packing: load.shipment.packing.name,
            weight: parseInt(load.shipment.weight!, 10),
            weightUnitMeasure: load.shipment.weightUnitMeasure,
            skids: load.shipment.skids
                ? parseFloat(load.shipment.skids)
                : undefined,
            freightOrder: load.shipment.freightOrder,
        },
        vehicle: load.vehicle!,
        checked: load.checked ?? false,
        confirmedBy: load.confirmedBy,
        winnerInfo: load.winnerInfo
            ? {
                  carrierCode: load.winnerInfo.carrierCode,
                  carrierName: load.winnerInfo.carrierName,
                  vehicleDescription: load.winnerInfo.vehicleDescription ?? null,
              }
            : undefined,
        planningDate: load.dates?.planningDate,
        isReturnable: load.isReturnable,
        ratesByVehicle: load.ratesByVehicle,
    };
}

export function hasRateForCarrier(rate?: ILoadRate): boolean {
    return rate !== undefined;
}

export function getPoolLoadTagStatusType(
    hasRates: boolean,
    status: LoadStatus,
    confirmedByOther: boolean,
): StatusTagProps {
    if (status === LoadStatus.Confirmed) {
        return {
            type: confirmedByOther ? 'warning' : 'positive',
            id: 'pool-load-tag-confirmed',
            dataTestId: 'pool-load-tag-confirmed',
            label: i18n.t('Confirmada'),
        };
    }

    if (hasRates) {
        return {
            type: 'neutral',
            id: 'pool-load-tag-waiting-confirmation',
            dataTestId: 'pool-load-tag-waiting-confirmation',
            label: i18n.t('AguardandoConfirmacao'),
        };
    }

    return {
        type: 'negative',
        id: 'pool-load-tag-no-rate',
        dataTestId: 'pool-load-tag-no-rate',
        label: i18n.t('NoRate'),
    };
}

export function getRouteDetails(route: ILoadRoute): IPoolLoadRouteDetails {
    return {
        source: {
            code: route.originCode,
            description: route.originDescription,
            city: route.source.city,
            federativeUnit: route.source.federativeUnit,
        },
        destination: {
            code: route.destinationCode,
            description: route.destinationDescription,
            city: route.destination.city,
            federativeUnit: route.destination.federativeUnit,
        },
    };
}
